"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index117.js"),s=require("./index118.js");var d=a.shared,t=s.uid,r=d("keys"),u=function(e){return r[e]||(r[e]=t(e))};exports.sharedKey=u;
